import { createStyles } from 'antd-style';
import React from 'react';

interface BrandSiderHeaderProps {
  logoSrc?: string;
  logoAlt?: string;
  title?: string;
  collapsed?: boolean;
}

const useStyles = createStyles(({ token, css }) => {
  return {
    root: css`
      padding: 16px 16px 12px;
      display: flex;
      align-items: center;
      min-height: 48px;
      background: #f7f7f8;
    `,
    rootCollapsed: css`
      justify-content: center;
      padding-inline: 8px;
    `,
    compactMark: css`
      width: 32px;
      height: 32px;
      border-radius: 10px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border: none;
      background: transparent;
      overflow: hidden;
    `,
    compactLogo: css`
      width: 20px;
      height: 20px;
      object-fit: contain;
      display: block;
    `,
    fallbackMark: css`
      font-size: 16px;
      line-height: 1;
      font-weight: 600;
      color: ${token.colorTextHeading};
      letter-spacing: -0.01em;
    `,
    expandedLogo: css`
      display: block;
      width: 100%;
      max-width: 136px;
      max-height: 26px;
      object-fit: contain;
      object-position: left center;
    `,
    title: css`
      font-size: 16px;
      line-height: 24px;
      font-weight: 600;
      color: ${token.colorTextHeading};
      letter-spacing: -0.01em;
    `,
  };
});

const BrandSiderHeader: React.FC<BrandSiderHeaderProps> = ({
  logoSrc,
  logoAlt,
  title = 'AI Nexus',
  collapsed = false,
}) => {
  const { styles, cx } = useStyles();
  const fallbackMark = title.trim().charAt(0).toUpperCase() || 'A';

  if (collapsed) {
    return (
      <div className={cx(styles.root, styles.rootCollapsed)}>
        <div className={styles.compactMark}>
          {logoSrc ? (
            <img src={logoSrc} alt={logoAlt || title} className={styles.compactLogo} />
          ) : (
            <span className={styles.fallbackMark}>{fallbackMark}</span>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className={styles.root}>
      {logoSrc ? (
        <img src={logoSrc} alt={logoAlt || title} className={styles.expandedLogo} />
      ) : (
        <span className={styles.title}>{title}</span>
      )}
    </div>
  );
};

export default BrandSiderHeader;
